import { render, staticRenderFns } from "./BoxDelivery.vue?vue&type=template&id=1e62126d&"
import script from "./BoxDelivery.vue?vue&type=script&lang=js&"
export * from "./BoxDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports